import NewApiService from "@/utils/new.api.service";
export default{
    search(context, {term, type}) {
        return new Promise((resolve, reject) => {
          NewApiService.get("search", {
            search: term,
            type: type
          })
            .then(({ data }) => {
              resolve(data);
            })
            .catch(({ response }) => {
              reject(response)
            });
        });
      },
}